import {
  EducationActions,
  EducationActionTypes
} from '@staff-app/actions/education.actions';
import {EducationsDTO} from '@staff-app/models/educationDTO';

export interface State {
  educations: EducationsDTO;
}

export const initialState: State = {
  educations: null
};

export function reducer(state = initialState, action: EducationActions): State {
  switch (action.type) {
    case EducationActionTypes.GetEducationsSuccessful: {
      return {
        ...state,
        educations: action.payload
      };
    }
    case EducationActionTypes.SaveEducations:
    case EducationActionTypes.NavigateAway: {
      return initialState;
      // remove store to prevent data load from cache
    }
    default: {
      return state;
    }
  }
}

export const getEducations = (state: State) => state.educations;
